import {API_BASE_URL, getMetaDataList, getUsersList} from '@/libs/api/api'
import {onError} from '@/libs/helper'
import {isEmpty} from 'lodash'

export default {
    name: 'SearchDropdown',
    props: {
        module: {
            type: String,
        },
        setMetaToAdd: {
            type: Function,
            default: ()=>{}
        },
        clear: {
            type: Boolean,
            default: false
        },
        isBulkEdit: {
            type:Boolean,
            default: false
        },
        isMultiple:{
            type: Boolean,
            default: true
        },
        result: {
            type: Array,
            default: () => {}
        },
        changeSearch: {
            type: Function,
        },
        isAnalyse:{
            type: Boolean,
            default: false
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        className: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            authorToAdd: {},
            claimTo: '',
            onError: onError,
            list: []
        }
    },
    watch: {
        clear (value) {
            if (value) {
                this.claimTo = ''
            }
        },
        result (value) {
            this.list = value
        }
    },
    methods: {
        querySearch: async function(queryString, cb) {
            if(isEmpty(queryString) || queryString.split('').length < 2){
                return
            }

            let searchResult = []
            let body = {
                search_text: queryString,
                type: this.module
            }

            try{
                if(this.module !== 'USER') searchResult = await this.searchFollowers(body)
                else {
                    delete body.type
                    searchResult = await getUsersList(body)
                    searchResult = searchResult['USERS']
                }
            }catch(error){
                return
            }
            // call callback function to return suggestion objects
            cb(searchResult);
        },
        handleSelect(selectedAuthor){
            this.authorToAdd = selectedAuthor
            this.claimTo = `${this.authorToAdd._id} ${this.authorToAdd.name || this.authorToAdd.first_name}`
            this.setMetaToAdd(selectedAuthor)
            //this.setClaimTo(selectedAuthor)
        },
        getURL(imageName){
            return `${API_BASE_URL}/accounts/files/${imageName}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        /**
         * API call to fetch theauthor, publication, publisher by text/string.
         * @params {object} body to send in the API call
         * @params {object} params to add with the API URL
         */
        searchFollowers (body) {
            return getMetaDataList(body).then((response) => {
                if (this.module === 'AUTHOR') return response[`${this.module}S`] 
                return response[`${this.module}S`] 
            }).catch((error) => {
                return error
            })
        },
        handleSearch (item) {
            this.authorToAdd = item
            this.claimTo = `${this.authorToAdd.name || this.authorToAdd.first_name}`
            this.changeSearch(this.module, item)
        }
    }
}